import Invoice from "../../services/invoice";
import axios from "axios";

export default {
  data() {
    return {
      state: undefined,
      invoices: undefined,
      loading: false,
      messageError: undefined,
      visibleMenuId: null,
      nfeLinks: {},
      nfeChecked: {},
      nfeStatus: {},
      toastNfeVisible: false,
      toastNfeTimeout: null,
    };
  },
  computed: {
    contractId() {
      return this.$route.params.contractId;
    },
  },
  mounted() {
    this.state = "LOADING";
    this.loading = Invoice.list(this.contractId)
      .then((resp) => {
        this.invoices = resp;
        this.state = "LOADED";
        if (this.invoices.length === 0) {
          this.messageError =
            "Nenhuma fatura encontrada para o contrato em questão.";
        }
      })
      .catch((err) => {
        this.messageError =
          (err.data && err.data.status && err.data.status.message) ||
          "Desculpe-nos ocorreu um problema, por favor tente novamente";
      });
  },
  methods: {
    toggleMenu(invoiceId) {
      this.visibleMenuId = this.visibleMenuId === invoiceId ? null : invoiceId;
      if (this.visibleMenuId && this.nfeChecked[invoiceId] === undefined) {
        this.getLinkNFe(invoiceId)
          .then((data) => {
            let url = null;
            let found = false;
            let code = 0;
            let message = "";
            if (
              data &&
              data.status &&
              typeof data.status.code !== "undefined"
            ) {
              code = data.status.code;
              message = data.status.message;
            }
            if (
              data &&
              data.return &&
              Array.isArray(data.return) &&
              data.return.length > 0
            ) {
              found = true;
              url = data.return[0].url || null;
            }
            this.$set(this.nfeLinks, invoiceId, url);
            this.$set(this.nfeChecked, invoiceId, found);
            this.$set(this.nfeStatus, invoiceId, { code, message });
          })
          .catch((err) => {
            let code = -1;
            let message = "Erro desconhecido";
            if (err.response && err.response.data && err.response.data.status) {
              code = err.response.data.status.code;
              message = err.response.data.status.message;
            }
            if (code === 9002) {
              this.$set(this.nfeLinks, invoiceId, null);
              this.$set(this.nfeChecked, invoiceId, true);
            } else {
              this.$set(this.nfeLinks, invoiceId, null);
              this.$set(this.nfeChecked, invoiceId, false);
            }
            this.$set(this.nfeStatus, invoiceId, { code, message });
          });
      }
    },
    showNfeToast() {
      if (this.toastNfeTimeout) {
        clearTimeout(this.toastNfeTimeout);
      }
      this.toastNfeVisible = true;
      this.toastNfeTimeout = setTimeout(() => {
        this.toastNfeVisible = false;
        this.toastNfeTimeout = null;
      }, 3000);
    },
    getPdf(id, planId) {
      return planId !== 28
        ? `/api/v2/invoice/pdf/${id}`
        : `/api/v1/invoice/pdf/${id}`;
    },
    getXlsx(id, planId) {
      return planId !== 28
        ? `/api/v2/invoice/xlsx/${id}`
        : `/api/v1/invoice/xlsx/${id}`;
    },
    getTxt(id) {
      return `/api/v2/invoice/txt/${id}`;
    },
    async getLinkNFe(invoiceId) {
      const res = await axios.get(`/v2/invoice/linkNFe/${invoiceId}`);
      return res.data;
    },
    buildBoletoUrl(inv) {
      return inv.boleto
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/account/invoice-history.js